import { z } from "zod";
export const Recaptcha = z.object({ recaptchaToken: z.string(), email: z.string().email() });
export const RecaptchaAction = {
    Login: "login",
    Register: "register",
    PasswordReset: "password_reset",
    RequestPasswordReset: "request_password_reset",
    VerifyEmail: "verify_email",
};
//# sourceMappingURL=recaptcha.js.map